<template>
  <div>
    <h3>Districts Certified</h3>
    <div v-if="districts.length" class="mb-2">
      <strong>Total Districts Certified: {{ districts.length }}</strong>
    </div>
    <b-table :items="districts" :fields="fields" striped hover small v-if="districts.length">
      <template v-slot:cell(districtLEA)="data">
        <div>
          <span :id="data.index + '-' + data.value">
            {{ leaFormatter(data.value) }}
          </span>
          <lea-tooltip :target-selector="data.index + '-' + data.value" :lea-number="data.value" />
        </div>
      </template>
      <template v-slot:cell(lastUpdatedDate)="data">
        <span>{{ formatDate(data.value) }}</span>
      </template>
      <template v-slot:cell(actions)="data">
        <b-button size="sm" variant="danger" @click="deleteCertification(data.item)" :disabled="loading">
          <i class="fa fa-trash" /> Remove
        </b-button>
      </template>
    </b-table>
    <div v-else class="text-muted">
      No districts have marked as certified for the selected year.
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import LeaTooltip from '@/components/LeaTooltip.vue'

export default {
  data() {
    return {
      districts: [],
      fields: [
        { key: 'districtLEA', label: 'District LEA', sortable: true },
        { key: 'lastUpdatedBy', label: 'Certified By', sortable: true },
        { key: 'lastUpdatedDate', label: 'Certified Date', sortable: true },
        { key: 'actions', label: '', sortable: false },
      ],
      fiscalYearOptions: [],
      loading: false,
    };
  },
  components: {
    LeaTooltip
  },
  computed: {
    ...mapState('tgsModule', ['loadedYears', 'fiscalYear']),
    isAdmin() {
      return this.$store.state.globalModule.userContext && this.$store.state.globalModule.userContext.isInsightsAdmin;
    }
  },
  watch: {
    fiscalYear: {
      immediate: true,
      handler(newVal) {
        if (newVal) this.fetchCertifiedDistricts();
      }
    },
  },
  methods: {
    formatDate(val) {
      if (!val) return '';
      return new Date(val).toLocaleString();
    },
    async deleteCertification(item) {
      if (!confirm('Are you sure you want to delete this certification?')) return;
      this.loading = true;
      try {
        const res = await fetch(`/api/merit-incentive/${this.fiscalYear}/${item.districtLEA}/certify`, { method: 'DELETE' });
        if (res.ok) {
          this.districts = this.districts.filter(d => d.districtLEA !== item.districtLEA);
        } else {
          alert('Failed to delete certification.');
        }
      } catch (e) {
        alert('Failed to delete certification.');
      } finally {
        this.loading = false;
      }
    },
    async fetchCertifiedDistricts() {
      this.loading = true;
      try {
        const res = await fetch(`/api/merit-incentive/${this.fiscalYear}/certified`);
        if (res.ok) {
          this.districts = await res.json();
        } else {
          this.districts = [];
        }
      } catch (e) {
        this.districts = [];
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
